/**
 * Default method to walk an AST an invoke the corresponding listener methods for each node.
 *
 * @param listener Listener to invoke enter and exit methods
 * @param jast JQL AST to walk
 */
export var walkAST = function walkAST(listener, jast) {
  jast.query && walkNode(listener, jast.query);
};
var walkNode = function walkNode(listener, node) {
  listener.enterEveryNode && listener.enterEveryNode(node);
  node.enterNode(listener);
  node.getChildren().forEach(function (child) {
    return walkNode(listener, child);
  });
  node.exitNode(listener);
  listener.exitEveryNode && listener.exitEveryNode(node);
};